import {Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, OnDestroy} from '@angular/core';
import {CommentsModel} from '../../../common/services/comments/comments.model';
import {CommentTypeEnum} from '../../../common/services/enums/commentTypeEnum';
import {Individu} from '@Common/core/services';
import {CommentsService} from '../../../common/services/comments/comments.service';
import {SubSink} from '@Common/core/utils/subsink';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CommentComponent implements OnInit, OnDestroy {
  @Input() comment: CommentsModel;
  @Input() individu: Individu;
  @Output() editComment = new EventEmitter<CommentsModel>();
  @Output() delComment = new EventEmitter<CommentsModel>();
  commentId = null;
  commentTypeEnum = CommentTypeEnum;
  subSink = new SubSink();

  constructor(private commentSvc: CommentsService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
  }
  openEditComment(): void {
    this.editComment.emit(this.comment);
  }

  deleteComment(): void {
      const data = new DialogData();
      data.title = 'Suppression d\'un commentaire';
      data.message = 'Souhaitez-vous supprimer ce commentaire ?';
      data.iconType = 'warning';

      const dialogRef = this.dialog.open(DialogValidationComponent, {
        data: data
      });

      dialogRef.updatePosition({ top: '40px' });
      this.subSink.sink = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.subSink.sink = this.commentSvc.delete(this.comment).subscribe(
            _data => {
              this.delComment.emit(this.comment);
            }
          );
        }
      });
  }
  ngOnDestroy(): void {}
}
